import { Heart } from 'lucide-react';
import PageHeader from '@/components/PageHeader';
import CadernoSection from '../home/components/CadernoSection';

export default function Messages() {
  return (
    <main className="messages-page-valentina section-surface">
      <div className="messages-flower messages-flower-top" aria-hidden="true" />
      <div className="messages-flower messages-flower-bottom" aria-hidden="true" />
      <PageHeader />
      <section className="messages-hero">
        <Heart size={18} fill="currentColor" />
        <h1>Palavras para guardar</h1>
        <p>Um espaço para registrar todo o carinho deste momento especial.</p>
      </section>
      <CadernoSection />
    </main>
  );
}
